/**
 * Card Type Constants for iFrame Integration
 * Maps card type names to their corresponding IDs for API communication
 */
export const CardType = {
    VISA: {
        id: 1,
        name: 'Visa'
    },
    MASTERCARD: {
        id: 2,
        name: 'MasterCard'
    },
    DISCOVER: {
        id: 3,
        name: 'Discover'
    },
    AMERICAN_EXPRESS: {
        id: 4,
        name: 'American Express'
    }
};

/**
 * Maps card type names from iFrame response to card type IDs
 * @param {string} cardTypeName - The card type name from iFrame (e.g., "Visa", "MasterCard")
 * @returns {number|null} The corresponding card type ID, or null if not found
 */
export const getCardTypeId = (cardTypeName) => {
    if (!cardTypeName) return null;
    
    const normalizedCardType = cardTypeName.toLowerCase().trim();
    
    switch (normalizedCardType) {
        case 'visa':
            return CardType.VISA.id;
        case 'mastercard':
        case 'master card':
        case 'mc':
        case 'mast':
            return CardType.MASTERCARD.id;
        case 'discover':
        case 'disc':
            return CardType.DISCOVER.id;
        case 'american express':
        case 'americanexpress':
        case 'amex':
            return CardType.AMERICAN_EXPRESS.id;
        default:
            console.warn(`Unknown card type from iFrame: ${cardTypeName}`);
            return null;
    }
};

/**
 * Specifically maps iFrame card type responses to card type IDs
 * This is an alias for getCardTypeId with more specific naming for iFrame integration
 * @param {string} iFrameCardType - The card type from iFrame response
 * @returns {number|null} The corresponding card type ID, or null if not found
 */
export const getCardTypeIdFromIFrame = (iFrameCardType) => {
    return getCardTypeId(iFrameCardType);
};

/**
 * Gets the card type name by ID
 * @param {number} cardTypeId - The card type ID
 * @returns {string|null} The card type name, or null if not found
 */
export const getCardTypeName = (cardTypeId) => {
    const cardTypeEntry = Object.values(CardType).find(type => type.id === cardTypeId);
    return cardTypeEntry ? cardTypeEntry.name : null;
};

/**
 * All available card types as an array
 */
export const CARD_TYPES = Object.values(CardType);